import { EditorProvider } from "./EditorContext";

import { LexicalComposer } from "@lexical/react/LexicalComposer";
import { HistoryPlugin } from "@lexical/react/LexicalHistoryPlugin";

import { ListPlugin } from "@lexical/react/LexicalListPlugin";
import { LinkPlugin } from "@lexical/react/LexicalLinkPlugin";
import { AutoLinkPlugin } from "@lexical/react/LexicalAutoLinkPlugin";

import { ListNode, ListItemNode } from "@lexical/list";
import { LinkNode, AutoLinkNode } from "@lexical/link";
import { $generateNodesFromDOM } from "@lexical/html";
import { $getRoot } from "lexical";


import { TopToolbar, BottomToolbar } from "./plugins/ToolbarPlugin";
import PasteImagePlugin from "./plugins/PasteImagePlugin";
import AttachmentsPlugin from "./plugins/AttachmentsPlugin";
import NewMentionsPlugin from "./plugins/MentionsPlugin";
import ContentEditablePlugin from "./plugins/ContentEditablePlugin";
import { MentionNode } from "./nodes/MentionNode";
import EditablePlugin from "./plugins/EditablePlugin";

export default function LexicalEditor(props) {
	const { editable = true } = props; // Default to true if not provided

	const initialConfig = {
		namespace: "thread-editor",
		theme: {
			text: {
				bold: "font-bold",
				italic: "italic",
				underline: "underline",
				strikethrough: "line-through",
			}
		},
		onError(error) {
			console.error(error);
		},

		// register nodes so plugins can work
		nodes: [ListNode, ListItemNode, LinkNode, AutoLinkNode, MentionNode],
 
		editorState: (editor) => {
			const defaultHtml = props.defaultValue || '';
			if (!defaultHtml.trim()) return;

			const parser = new DOMParser();
			const dom = parser.parseFromString(defaultHtml, "text/html");

			editor.update(() => {
				const root = $getRoot();
				root.clear();

				const nodes = $generateNodesFromDOM(editor, dom);
				root.append(...nodes);
			});
		}
	};

	const urlMatcher = (text) => {
		const urlRegex = /https?:\/\/[^\s]+/i;
		const match = text.match(urlRegex);
		if (match === null) return null;

		return {
			index: match.index,
			length: match[0].length,
			text: match[0],
			url: match[0],
		};
	}
	return (
		<LexicalComposer initialConfig={initialConfig}>
			<EditorProvider {...props}>
				<div className="relative border rounded-primary flex flex-col min-h-24 w-full bg-white lexical-editor-threads">
					<EditablePlugin editable={editable} />
					<HistoryPlugin />
					<ListPlugin />
					<LinkPlugin />
					<AutoLinkPlugin matchers={[urlMatcher]} />
					<PasteImagePlugin />
					<NewMentionsPlugin api={``} />
					<TopToolbar />
					<ContentEditablePlugin />

					<AttachmentsPlugin />

					<BottomToolbar />
				</div>
			</EditorProvider>
		</LexicalComposer>
	);
}
